export default __webpack_public_path__ + "static/CommunityEngagement-df7ed04ca424ae1664862d19049517b7.jpg";